import API from 'services/API';
import { transformRequestOptions } from 'utils/requestParamsSerializers/requestParamsSerializers';

export default function hasUnits(options) {
  return API.request({
    method: 'GET',
    url: '/taxpayer/hasUnits',
    params: options,
    paramsSerializer: (params) => transformRequestOptions(params),
  });
}
